import styles from './ProgressBar.module.scss'

interface IProps {
    percents: string
    label?: string
    size?: 'small' | 'medium' | 'large'
    color?: 'primary' | 'success' | 'warning' | 'error'
}

export const ProgressBar = (props: IProps) => {
    const { percents, size = 'medium', color = 'primary', label = 'Идет процесс импорта...' } = props

    return (
        <div className={`${styles.container} ${styles[size]} ${styles[color]}`}>
            <div className={styles.label}>
                <span>{label}</span>
            </div>
            <div className={styles.progressTrack}>
                <div className={styles.progressFill} style={{ width: percents }}>
                    {size === 'large' && <span className={styles.innerLabel}>{percents}</span>}
                </div>
            </div>
        </div>
    )
}
